var ps_sku_tracker = {
    utms: {
        source: null,
        medium: null,
        campaign: null,
    },    
    init: function(){
        if(typeof ps_sku_tracker_data !== 'undefined'){
            localStorage.setItem('ps_sku', JSON.stringify(ps_sku_tracker_data.sku));
        }else{
            localStorage.removeItem('ps_sku');
        }

        var location = window.location.href;
        var params = new URLSearchParams(location.split('?')[1]);
        var utms_present = false;
        if (params.has('utm_source')) {
            ps_sku_tracker.utms.source = params.get('utm_source');
            utms_present = true;
        }
        if (params.has('utm_medium')) {
            ps_sku_tracker.utms.medium = params.get('utm_medium');
            utms_present = true;
        }
        if (params.has('utm_campaign')) {
            ps_sku_tracker.utms.campaign = params.get('utm_campaign');
            utms_present = true;
        }
        if (ps_sku_tracker.utms.source || ps_sku_tracker.utms.medium || ps_sku_tracker.utms.campaign) {
            localStorage.setItem('ps_sku_utms', JSON.stringify(ps_sku_tracker.utms));
        }else if(!utms_present){
            saved_utms = localStorage.getItem('ps_sku_utms');
            if(saved_utms){
                ps_sku_tracker.utms = JSON.parse(saved_utms);
            }
        }
    },
};

window.ps_sku_tracker = ps_sku_tracker;

jQuery(document).ready(function($){
    ps_sku_tracker.init();
});